import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
// ✅ CORRECCIÓN: Usar useTimezone en lugar de moment directamente
import { useTimezone } from '../../hooks/useTimezone';

const useStyles = makeStyles((theme) => ({
    inline: {
        width: '100%'
    }
}));

export default function ContactNotesDialogListItem (props) {
    const { note, deleteItem } = props;
    const classes = useStyles();
    // ✅ CORRECCIÓN: Usar hook useTimezone para formatear fechas según timezone de la empresa
    const { formatDateTime } = useTimezone();

    const handleDelete = (item) => {
        deleteItem(item);
    }

    // ✅ CORRECCIÓN: Formatear fecha usando timezone de la empresa
    // formatDateTime devuelve "DD/MM/YYYY HH:mm", necesitamos convertir a "DD/MM/YY HH:mm"
    const getFormattedDate = () => {
        if (!note.createdAt) return '';
        const formatted = formatDateTime(note.createdAt);
        if (!formatted) return '';
        // Convertir "DD/MM/YYYY HH:mm" a "DD/MM/YY HH:mm" (año de 4 dígitos a 2)
        // Ejemplo: "19/01/2026 15:32" → "19/01/26 15:32"
        return formatted.replace(/(\d{2}\/\d{2}\/)(\d{4})(\s+\d{2}:\d{2})/, (match, p1, p2, p3) => {
            // p1 = "19/01/", p2 = "2026", p3 = " 15:32"
            const shortYear = p2.substring(2); // "2026" → "26"
            return `${p1}${shortYear}${p3}`;
        });
    };

    const displayDate = getFormattedDate();

    return (
        <ListItem alignItems="flex-start">
            <ListItemAvatar>
                <Avatar alt={note.user.name} src="/static/images/avatar/1.jpg" />
            </ListItemAvatar>
            <ListItemText
                primary={
                    <>
                        <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                        >
                            {note.note}
                        </Typography>
                    </>
                }
                secondary={
                    <>
                        {note.user.name}, {displayDate || (note.createdAt ? new Date(note.createdAt).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '')}
                    </>
                }
            />
            <ListItemSecondaryAction>
                <IconButton onClick={() => handleDelete(note)} edge="end" aria-label="delete">
                    <DeleteIcon />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    )   
}

ContactNotesDialogListItem.propTypes = {
    note: PropTypes.object.isRequired,
    deleteItem: PropTypes.func.isRequired
}